import React from 'react'
import { IconButton, IconButtonProps, SxProps, Tooltip } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { useClipboardCopy } from '@cbgms/base/hooks/use-clipboard-copy'

interface IProps extends IconButtonProps {
  value: string
  tooltip: string
  iconStyle?: SxProps
}

const CopyToClipboard: React.FC<IProps> = ({ tooltip, value, iconStyle, ...props }) => {
  const copy = useClipboardCopy()

  const copyToClipboard = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation()
    copy(value)
  }

  return value.length > 0 ? (
    <Tooltip title={tooltip} arrow tabIndex={0}>
      <IconButton color='primary' data-testid='copy-button' onClick={copyToClipboard} {...props}>
        <ContentCopyIcon sx={{ ...iconStyle }} />
      </IconButton>
    </Tooltip>
  ) : null
}

CopyToClipboard.displayName = 'CopyToClipboard'
export default CopyToClipboard
